import { ChangeDetectionStrategy, Component, effect, ElementRef, HostListener, input, output, signal, viewChild } from '@angular/core';
import { EtiquetteComponent } from "../etiquette/etiquette";
import { AbstractComponent } from '@spike/scaffolds';
import { Button } from 'primeng/button';
import { EntityEtiquette } from '../../models/entity-etiquette.model';

@Component({
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'spike-etiquette-list',
  providers:[],
  imports: [EtiquetteComponent, Button],
  templateUrl: './etiquette-list.html'
})
export class EtiquetteListComponent extends AbstractComponent{
  
  //input
  etiquetteList = input.required<EntityEtiquette[]>();
  selectedId = input<number|null>(null);
  noLabelName = input.required<string>();
  
  //output
  onSelect = output<number|null>();
  clickPropagated = output<MouseEvent>();

  private container = viewChild<ElementRef<HTMLDivElement>>('container');
  public isExpanded = signal(false);
  public hasOverflow = signal(false);

  constructor() {
    super()
    effect(() => {
      const el = this.container()?.nativeElement;
      if (!el) return;

      // Monitora il ridimensionamento o il cambio di contenuto
      const observer = new ResizeObserver(() => {
        // 40px è un'altezza indicativa per 1 riga (regolala in base ai tuoi componenti)
        // Se l'altezza totale (scrollHeight) > altezza riga singola
        this.hasOverflow.set(el.scrollHeight > 45); 
      });

      observer.observe(el);
      return () => observer.disconnect();
    });
  }

  getSeverity(etiquetteId: number|null): "info"|"secondary" {
    const currentSelected = this.selectedId();
    return currentSelected===etiquetteId ? "info" : "secondary"; 
  }
 
  onClick(event: any, etiquetteId: number|null){
    this.onSelect.emit(etiquetteId);
    this.clickPropagated.emit(event);

  }



  
}

    